<template id="ai-dashboard">
  <div>
    <v-card class="pa-6" flat>
    <aiInfoTable 
      :aiHeaders="aiHeaders" 
      :apiUrl="apiUrl" 
      :editable="editableAi"
      :clientId="$store.state.client"
      :filters="filters"
    />
    </v-card>
  </div>
</template>

<script>
import { updateFeatureById } from '@/modules/varianceanalysis/aiUtils/summary.js';
import aiInfoTable from '../../admin/views/components/AiInfoTable.vue';
import varianceAnalysisConstants from '@/modules/varianceanalysis/constants.js';

export default {
  name: 'GenAITable',
  props: {
    client: {
      type: String,
      required: true
    },
    aiEnabled: {
      type: Boolean,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tableData: [],
      loading: false,
      error: '',
      showDialog: false,
      dialogMode: 'view',
      dialogData: {},
      aiHeaders: [
        { text: 'Feature Name', value: 'feature_name',sortable: false, filterable: true },
        { text: 'Description', value: 'description',sortable: true, filterable: true },
        { text: 'Status', value: 'super_admin_enabled',sortable: false, filterable: true },
        { text: 'Prompt variants', value: 'prompt_variants_data',sortable: true, filterable: true },
        { text: 'Actions', value: 'actions', sortable: false, },
      ],
      apiUrl: '/v2/client/get-all-ai-featuresbyclient',
      editableAi: false,
      filters: {
        product: varianceAnalysisConstants.AI_FILTERS.PRODUCT,
        module: varianceAnalysisConstants.AI_FILTERS.MODULE
      }
    };
  },
  components: {
    aiInfoTable
  },
  created() {
    this.refreshData();
  },
  methods: {
    async refreshData() {
      this.loading = true;
      this.error = '';
      try {
        // Send client as payload if required by API
        const response = await this.axios.post(this.url, { client: this.client });
        if (response.data && response.data.status === 'success') {
          this.tableData = (response.data.features || [])
          if (this.$emit) this.$emit('refreshed', this.tableData);
        } else {
          this.tableData = [];
          this.error = response.data?.message || 'No data found';
          if (this.$emit) this.$emit('refreshed', []);
        }
      } catch (err) {
        this.tableData = [];
        this.error = err.message || 'Error fetching data';
        if (this.$emit) this.$emit('refreshed', []);
      } finally {
        this.loading = false;
      }
    },
    editItem(item) {
      if (!this.editable) return;
      this.dialogData = { ...item };
      this.dialogMode = 'edit';
      this.showDialog = true;
    },
    showDetails(item) {
      this.dialogData = { ...item };
      this.dialogMode = 'view';
      this.showDialog = true;
    },
    async saveEdit(dialogData) {
      console.log(dialogData,"dialogData" ,this.$store.state.client);
      
      try {
        // Only send required fields: status, id, and client if present
        const updatePayload = {
          id: dialogData._id,
          platform_admin_enabled: dialogData.platform_admin_enabled,
          super_admin_enabled: dialogData.super_admin_enabled,
          threshold: dialogData.threshold,
          // client: this.$store.state.client
        };
        if (this.client) {
          updatePayload.client = this.client;
        }
        const response = await updateFeatureById(this.axios, updatePayload);
        if (response && response.status === 'success') {
          this.$toast && this.$toast.success('Status changed successfully');
        } else {
          let msg = (response && response.message) ? response.message : 'Failed to update feature';
          this.$toast && this.$toast.error(msg);
        }
      } catch (err) {
        let msg = (err && err.message) ? err.message : 'Failed to update feature';
        this.$toast && this.$toast.error(msg);
      } finally {
        this.showDialog = false;
        this.refreshData();
      }
    },
  }
};
</script>

<style scoped>
  .genai-table tbody tr {border-bottom: 1px solid #e0e0e0;}
  .genai-table tbody td {border-bottom: none !important; padding: 14px 18px !important;}
  .genai-table thead th {padding: 16px 20px !important; font-size: 15px;}
  .minWid {min-width: 300px;}
  .border-lt-rt th,
  .border-lt-rt td {border-left: 1px solid #e0e0e0; border-right: 1px solid #e0e0e0;}
</style>